// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"77f3bab6da7f9712","5763":"2cc8ae7cea31c813","7222":"f0d226677c3ecb0b","7937":"333c54d02aa15368"}[chunkId] + ".js";
};